export default {"src":"/_next/static/media/tub_with_shower_bench.273d4507.svg","height":100,"width":100};